
import Service from '../section/servicepage/Service'
export default function ServicePage() {
  return (
    <div className="h-full">
        <Service/>
    </div>
  )
}